import { render, staticRenderFns } from "./ApkUpdates.vue?vue&type=template&id=6771f597&"
import script from "./ApkUpdates.vue?vue&type=script&lang=js&"
export * from "./ApkUpdates.vue?vue&type=script&lang=js&"
import style0 from "./ApkUpdates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports